module.exports = __webpack_public_path__ + "static/download_file_outlined.cd37904b.svg";